// extracted by mini-css-extract-plugin
module.exports = {"careers__section":"Careers-module--careers__section--rnd6X"};